<template>
  <div :class="[classes.cardHeader]">
    <div :class="[classes.fade, classes.fadeOut]">
      <Live v-if="event?.live">
        <FixtureDate class="live">{{ live }}</FixtureDate>
      </Live>
      <FixtureDate v-else :class="[classes.fixtureDate, 'fixture-start-date']">
        {{ fixtureStartDate }}
      </FixtureDate>
      <FixtureSport
        v-if="showMarket"
        :id="marketBranding?.marketNameFont"
        :class="[classes.fixtureSport, 'sport']"
      >
        {{ ` ${eventName}` }}
      </FixtureSport>
    </div>
    <div :class="[classes.fade, classes.fadeIn]">
      <FixtureSport
        v-if="!showMarket"
        :id="marketBranding?.marketNameFont"
        :class="[classes.fixtureSport, 'sport']"
      >
        {{ eventName }}
      </FixtureSport>
      <MarketName v-else :class="[classes.marketName, 'market']">
        {{ marketName }}
      </MarketName>
    </div>
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, defineComponent } from "vue";

import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { composeEvent } from "@fresh8/ad-data-composition/src/betData";
import { getTranslation } from "@fresh8/ad-data-composition/src/lang";
import composeDate from "@fresh8/ad-data-composition/src/date";
import { getSport } from "../lib/language";

import Live from "./Live.vue";
import FixtureDate from "./branded/FixtureDate.vue";
import FixtureSport from "./branded/FixtureSport.vue";
import MarketName from "./branded/MarketName.vue";
import { composeMarket } from "@fresh8/ad-data-composition/src/betData";

const useStyles = createUseStyles({
  cardHeader: {
    width: "100%",
    fontSize: "9px",
    boxSizing: "border-box",
    position: "relative",
    height: "17px",
    flex: "1 0 17px",
    padding: "0 6px",
    maxHeight: "17px",
    display: "flex",
    alignItems: "center"
  },
  fixtureDate: {
    flex: 1
  },
  fixtureSport: {
    flex: 1
  },
  marketName: {
    flex: 1
  },
  fade: {
    position: "absolute",
    alignItems: "center",
    animation: "$fadeInOut 4s linear 2s infinite",
    animationFillMode: "both"
  },
  fadeIn: {
    animationDirection: "alternate"
  },
  fadeOut: {
    animationDirection: "alternate-reverse"
  },
  "@keyframes fadeInOut": {
    "0%": { opacity: 0 },
    "50%": { opacity: 0 },
    "60%": { opacity: 1 },
    "100%": { opacity: 1 }
  }
});

export default defineComponent({
  name: "CardHeaderLeaderboard",
  components: {
    Live,
    FixtureDate,
    FixtureSport,
    MarketName
  },
  props: {
    eventId: { type: String, required: true },
    marketId: { type: String, required: false, default: "" },
    showMarket: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const brand = injectBrand();
    const classesRef = useStyles(brand?.adTemplateBranding);
    const event = composeEvent(props.eventId);
    const fixtureStartDate = composeDate(event.value?.id);
    const eventName = computed(() =>
      brand?.adTemplate?.value?.useCompetitionName
        ? event.value?.competition || ""
        : getSport(event.value?.sport)
    );

    const market = composeMarket(props.marketId);
    const marketName = computed(() => market.value?.marketName);

    const live = computed(
      () =>
        getTranslation(window.navigator.language.toLowerCase()).DateTimeTexts
          .Live
    );

    return {
      classes: classesRef,
      event,
      eventName,
      fixtureStartDate,
      marketBranding: computed(() => brand?.marketBranding.value),
      marketName,
      live
    };
  }
});
</script>
